import { type CSSProperties } from "react";
import { useNavigate } from "react-router";
import { useListMyTasks } from "../../hooks/use-list-my-tasks";

/**
 * Top-chrome "My tasks" affordance (Sprint 7). Shows a clipboard button with a
 * count badge of open + in-progress tasks assigned to the signed-in user;
 * clicking navigates to /my-tasks. The count rides the shared `my-tasks` query
 * cache, so it updates reactively as tasks are created or completed anywhere.
 */
export function MyTasksBadge() {
  const navigate = useNavigate();
  const myTasks = useListMyTasks();

  const count = (myTasks.data?.tasks ?? []).filter(
    (t) => t.status === "pending" || t.status === "in_progress",
  ).length;

  const button: CSSProperties = {
    position: "relative",
    border: "none",
    background: "transparent",
    padding: 6,
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  };

  const badge: CSSProperties = {
    position: "absolute",
    top: 0,
    right: 0,
    minWidth: 15,
    height: 15,
    padding: "0 3px",
    boxSizing: "border-box",
    background: "var(--c-red-600)",
    color: "#fff",
    fontSize: 9,
    fontWeight: 600,
    lineHeight: "15px",
    borderRadius: 999,
    textAlign: "center",
    fontVariantNumeric: "tabular-nums",
  };

  return (
    <button
      onClick={() => navigate("/my-tasks")}
      style={button}
      aria-label={`My tasks${count > 0 ? ` (${count})` : ""}`}
      title="My tasks"
    >
      <i className="ti ti-checklist" style={{ fontSize: 18, color: "var(--color-text-secondary)" }} aria-hidden="true" />
      {count > 0 && <span style={badge}>{count > 9 ? "9+" : count}</span>}
    </button>
  );
}
